import { css } from 'styled-components';

const formControlMixin = css<{ hasError?: boolean }>`
  width: 100%;
  line-height: 1.42857143;

  color: #555;
  padding: 6px 12px;
  border-radius: 3px;

  font-size: 16px;
  border: 1px solid ${({ theme, hasError }) => (hasError ? theme.color.error : theme.form.color.border)};

  ::placeholder {
    color: ${({ theme }) => theme.form.color.placeholder};
  }
  :focus {
    border-color: ${({ theme }) => theme.form.color.borderFocus};
  }
`;

export default formControlMixin;
